import React, { useEffect, useRef, useState } from "react";
import { Form, Table } from "react-bootstrap";
import { useReactToPrint } from "react-to-print";
import Moment from "react-moment";
import GLXMAKEDATA from "./ProcedureOutputDesign/GLXMAKEDATA";
import GLXOutputCommonTable from "./ProcedureOutputDesign/GLXOutputCommonTable";
import GLXBABEGLM from "./ProcedureOutputDesign/GLXBABEGLM";
import { PageLoader } from "../../../../Components/NoDataFoundTable/NoDataFoundTable";
import { editorProjectServices } from "../../../../APIServices/Editor/editorProjectServices";
import { useParams } from "react-router";
import GLXRPT from "./ProcedureOutputDesign/GLXRPT";
import GLXTTEST from "./ProcedureOutputDesign/GLXTTEST";

const ProjectOutputConsole = ({ ids, outputGeneratedDT, outputs, outputLoader, isFullScreenMode, isFullScreen, setIsFullScreen }) => {
  const outputRef = useRef(null);
  const [info, setInfo] = useState("");
  const [infoLoader, setInfoLoader] = useState(false);
  const { studyId } = useParams()

  const getProjectInformation = async (projectId, uniqueId) => {
    setInfoLoader(true)
    let data = await editorProjectServices.getProjectInformation(studyId, projectId, uniqueId)
    setInfo(data?.data || "")
    setInfoLoader(false)
  }

  useEffect(() => {
    if (ids?.projectId && ids?.uniqueId) {
      getProjectInformation(ids?.projectId, ids?.uniqueId);
    }
  }, [ids?.projectId, ids?.uniqueId]);

  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  return (
    <div className="overflow-hidden w-100">
      <div
        className="justify-content-between toolbar border-bottom hstack w-100 p-1"
        style={{ height: 35 }}
      >
        <div className="hstack gap-1">
          <i className="fa-solid fa-computer"></i>
          <h6 className="m-0">{ids?.name} Output</h6>
        </div>
        <div className="hstack gap-1">
          <i
            title="Print Outputs"
            className="fa-solid fa-print CP"
            onClick={handlePrint}
          />
          <div className="vr" />
          <i title={`${isFullScreen ? "Minimize" : "Maximize"} Console`} className={`fa-solid ${isFullScreen ? "fa-minimize" : "fa-maximize"} CP`} onClick={() => setIsFullScreen(!isFullScreen)} />
        </div>
      </div>
      <div
        ref={outputRef}
        className="p-2"
        style={{
          height: isFullScreenMode
            ? "calc(100vh - 70px)"
            : "calc(100vh - 216px)",
          overflowY: "auto",
          fontSize: `14px`,
        }}
      >
        {(outputLoader || infoLoader) ? (
          <PageLoader />
        ) : outputs?.length > 0 ? (
          <div ref={componentRef}>
            <Table className="m-0 mb-2 border-start border-end custom-table" bordered hover striped>
              <thead>
                <tr>
                  <th className="text-center" colspan={2}>Header Information</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Sponsor Name</td>
                  <td>{info?.sponsor}</td>
                </tr>
                <tr>
                  <td>Project Id</td>
                  <td>{info?.projectId}</td>
                </tr>
                <tr>
                  <td>Study Id</td>
                  <td>{info?.studyId}</td>
                </tr>
                <tr>
                  <td>Programmer Name</td>
                  <td>{info?.programmerName}</td>
                </tr>
                <tr>
                  <td>Project Name</td>
                  <td>{info?.name}</td>
                </tr>
                <tr>
                  <td>Program Name</td>
                  <td>{info?.fileName}.{info?.extension}</td>
                </tr>
                <tr>
                  <td>Current Program Version</td>
                  <td>v{info?.version}</td>
                </tr>
                <tr>
                  <td>Program Location</td>
                  <td title={`/${ids?.path}.${info?.extension}`}>
                    /{ids?.path}.{info?.extension}
                  </td>
                </tr>
                <tr>
                  <td>Generated Date | Time</td>
                  <td>
                    <Moment format="DD MMM YYYY | HH:mm:ss">
                      {outputGeneratedDT}
                    </Moment></td>
                </tr>
                <tr>
                  <td>Software Version</td>
                  <td>v2.0.0</td>
                </tr>
              </tbody>
            </Table>
            {outputs?.map((proc, idx) => {
              const procName = Object.keys(proc).find(key => key.startsWith("Procedure"));
              const output = (proc[procName] === "GLX RPT" || proc[procName] === "GLX REPORT") ? proc.output : (proc.output ? JSON.parse(proc.output.replace(/'/g, '"')) : []);
              return (
                <div className="mb-3">
                  <div className="text-center">
                    <Form.Label className="mb-2 fw-bold" style={{ fontSize: 12 }}>{procName?.replace("_", " ")}: {proc[procName]}</Form.Label>
                  </div>
                  {(proc[procName] === "GLX SORT" ||
                    proc[procName] === "GLX STATS" ||
                    proc[procName] === "GLX DUPLICATE" ||
                    proc[procName] === "GLX OCCURRENCE" ||
                    proc[procName] === "GLX SWITCH" ||
                    proc[procName] === "GLX APPEND" ||
                    proc[procName] === "GLX PK" ||
                    proc[procName] === "GLX TLFCNT" ||
                    proc[procName] === "GLX TLFSTATS" ||
                    proc[procName] === "GLX DATA" ||
                    proc[procName] === "GLX MERGE") &&
                    <GLXOutputCommonTable output={output} />
                  }
                  {proc[procName] === "GLX MAKEDATA" &&
                    <GLXMAKEDATA output={output} />
                  }
                  {proc[procName] === "GLX BABEGLM" &&
                    <GLXBABEGLM output={output} />
                  }
                  {(proc[procName] === "GLX TTEST" || proc[procName] === "GLX PROPTEST") &&
                    <GLXTTEST output={output} />
                  }
                  {(proc[procName] === "GLX RPT" || proc[procName] === "GLX REPORT") &&
                    <GLXRPT output={output} />
                  }
                </div>
              );
            })}
          </div>
        ) : (
          <div className="hstack justify-content-center h-100">
            <div className="px-2 fw-bold fontSize12 text-center">
              <div>Output not Found</div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ProjectOutputConsole;
